export const colors = {
  green: '#56bba4',
  orange: '#f1670e',
  blue: '#5da1d1',
  yellow: '#f6cd0d',
  navy: '#202e38',
};

export const shades = {
  green: {
    light: '#70dfcd',
    medium: '#56bba4',
    dark: '#288c7c',
  },
  orange: {
    light: '#fc9143',
    medium: '#f1670e',
    dark: '#c95400',
  },
  blue: {
    light: '#8ecdfa',
    medium: '#5da1d1',
    dark: '#467a9e',
  },
  yellow: {
    light: '#ffe364',
    medium: '#f6cd0d',
    dark: '#d4b00c',
  },
  navy: {
    light: '#3d586b',
    medium: '#202e38',
    dark: '#030405',
  },
};
